var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1920_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4581 16.3748C10.731 14.9428 9.87788 13.4964 8.21231 13.4964C7.89469 13.4964 7.57706 13.5489 7.28438 13.6828L6.72 12.5501C7.40906 11.9595 8.52206 11.4896 9.954 11.4896C12.1813 11.4896 13.3245 12.5633 14.2328 13.9309C14.7709 12.7628 15.0268 11.1838 15.0268 9.22688C15.0268 4.33913 13.4978 1.82963 9.92775 1.82963C6.41025 1.82963 4.88906 4.33913 4.88906 9.22688C4.88906 14.0884 6.41025 16.5716 9.92906 16.5716C10.4869 16.5716 10.9935 16.5112 11.4594 16.3748H11.4581ZM12.3309 18.081C11.548 18.2933 10.7403 18.401 9.92906 18.4013C5.24213 18.4013 0.65625 14.6633 0.65625 9.22688C0.65625 3.73931 5.24344 0 9.92775 0C14.6921 0 19.2334 3.71175 19.2334 9.22688C19.2334 12.2942 17.8028 14.7866 15.7224 16.3984C16.3944 17.4051 17.0874 18.0744 18.0495 18.0744C19.1021 18.0744 19.5261 17.2607 19.5969 16.6241H20.9659C21.0459 17.4733 20.622 21 16.7948 21C14.4756 21 13.2497 19.656 12.3309 18.081Z",
    fill: "#FFFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1920_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQf);
export default __webpack_public_path__ + "static/media/qf.08e06ee48db8476292a7596d7b08933d.svg";
export { ForwardRef as ReactComponent };